/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Carrier/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Carrier({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Carrier"
  
}) {
let assignedInsuranceInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
let constantData = '-'
let aggregateData = fromAggregate.any(assignedInsuranceInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="Carrier.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 data="'-'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}